module.exports = __webpack_public_path__ + "/8a4fff32de6a51c4324cfc6f86abe428.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/most_popular_cerulean_@2x.png
 ** module id = 1146
 ** module chunks = 0
 **/